// 宁夏国有资本
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        // {
        //     title: '场地预约',
        //     href: 'http://27.128.169.238:8088/otc/#/login?plan=nx&mRole=agent',
        //     activeReg: /(^\/yuyue*)/,
        //     click:`window.open('http://27.128.169.238:8088/otc/#/login?plan=nx&mRole=agent')`
        // },
        {
            title: 'CA办理/续费',
            href: '/cahandle',
            activeReg: /(^\/cahandle*)/,
            click:`window.open('/cahandle')`
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        }
    ],
    head: {
        title: '宁夏国有资本招投标交易平台',//全称
        title2: '宁夏国有资本',//简称
        jc_title: '宁夏国有资本',//简称
        citycode:'640000',//城市编号
        planName:'nx',
        caType:'nxcaapply',
        caHref:'https://online.cwca.com.cn/',//CA申请链接
        meta: {
            description: '宁夏国有资本招投标交易平台,交易平台,招投标,电子交易平台',
            keywords: '宁夏国有资本招投标交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '',
        logoUrl: '/nxgyzb/images/logo.png',//首页LOGO
        loginImgUrl: '/nxgyzb/images/loginImg.png',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://nxtb.huizezhao.cn/#/login?plan=nx',//投标登录
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://nxtb.huizezhao.cn/#/login?plan=nx',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://nxdl.huizezhao.cn/otc/#/login?plan=nx&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://nxdl.huizezhao.cn/otc/#/login?plan=nx&mRole=tender',
                title: '采购人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://nxpb.huizezhao.cn/?plan=nx',
                title: '评标登录',
                class: ''
            },
        ],
        userRolesZfcg:[
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://nxtb.huizezhao.cn/#/login?plan=nx',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://nxdl.huizezhao.cn/otc/#/login?plan=nx&mRole=agent',
                subHref: 'http://zfcgdl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://nxdl.huizezhao.cn/otc/#/login?plan=nx&mRole=tender',
                title: '采购人登录',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://nxpb.huizezhao.cn/?plan=nx',
                title: '评标登录',
            }
        ],
        friendLinks:[
            {
				href: 'https://ggzyjy.fzggw.nx.gov.cn',
				title: '宁夏回族自治区公共资源交易中心网站'
			},{
				href: 'https://www.ccgp-ningxia.gov.cn/index.html',
				title: '宁夏回族自治区政府采购网'
			},{
				href: 'https://www.nx.gov.cn/',
				title: '宁夏回族自治区人民政府网站'
			},{
				href: 'http://www.cebpubservice.com/',
				title: '中国招投标公共服务平台'
			}
        ],
        tel: '400-630-6886', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'nxhuizezhao@163.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '宁夏惠泽招科技发展有限公司',  //运营公司名称
        companyAddress: '',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'宁ICP备14001148号-1',
        gwIcp:'',
        products: [ //系列产品
            {
                href: 'http://www.zchzb.com',
                title: '中采惠招'
            },
            {
                href: 'http://www.zcebao.com/',
                title: '中采E保'
            },
            {
                href: 'http://zchr.xjf.limofang.cn/',
                title: '惠采商城'
            },
            {
                href: '/',
                title: '专家一体化平台'
            },
        ],
        closeAboutTitle: true,//关闭关于我们标题
        defaultType: 'zbgg',//交易信息列表招标内容 默认搜索条件
    },
    proxy: {
        '/web': {
            target: 'https://www.huizezhao.cn/',
            changeOrigin:true,
        },
    },
}